import { combineReducers } from 'redux'
import * as actions from '../actions'
// TODO fix
// eslint-disable-next-line complexity,sonarjs/cognitive-complexity
const all = (state = {}, action) => {
  switch (action.type) {
    case actions.RECEIVED_VIEWER:
      return {
        ...state,
        [action.data._id]: {
          ...action.data,
          reviewsStatus: {
            isLoading: false,
            hasMore: true,
            limit: 10,
            skip: 0
          }
        }
      }
    default:
      return state
  }
}

const usernames = (state = {}, action) => {
  switch (action.type) {
    case actions.RECEIVED_VIEWER:
      return {
        ...state,
        [action.data.username]: action.data._id
      }
    default:
      return state
  }
}

// TODO fix
// eslint-disable-next-line complexity
const reviews = (state = {}, action) => {
  switch (action.type) {
    case actions.RECEIVED_VIEWER:
      return state[action.data._id]
        ? state
        : {
            ...state,
            [action.data._id]: {
              isLoading: false,
              items: [],
              hasMore: true,
              limit: 10,
              skip: 0,
              error: false,
              fetched: false
            }
          }
    default:
      return state
  }
}

const followers = (state = {}, action) => {
  switch (action.type) {
    case actions.RECEIVED_VIEWER:
      return state[action.data._id]
        ? state
        : {
            ...state,
            [action.data._id]: {
              isLoading: false,
              items: [],
              hasMore: true,
              limit: 10,
              skip: 0,
              error: false,
              fetched: false
            }
          }
    default:
      return state
  }
}

// TODO fix
// eslint-disable-next-line complexity
const viewer = (
  state = { isLoading: false, _id: null, error: false },
  action
) => {
  switch (action.type) {
    case actions.FETCHING_VIEWER:
      return {
        ...state,
        isLoading: true,
        error: false
      }
    case actions.RECEIVED_VIEWER:
      return {
        isLoading: false,
        _id: action.data._id,
        error: false
      }
    case actions.UPDATING_VIEWER:
      return {
        ...state,
        isLoading: true
      }
    case actions.UPDATED_VIEWER:
      return {
        ...state,
        isLoading: false,
        error: false
      }
    case actions.ERROR_FETCHING_VIEWER:
      return {
        isLoading: false,
        _id: null,
        error: true
      }
    case actions.ERROR_UPDATING_VIEWER:
      return {
        ...state,
        error: true
      }
    case actions.LOG_OUT:
      return {
        isLoading: false,
        _id: null,
        error: false
      }
    default:
      return state
  }
}

export default combineReducers({
  all,
  usernames,
  reviews,
  viewer,
  followers
})
